import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { determineAppEnvironment } from "../EzEnviornmentInfo/EzEnviornmentInfo";
import "./Faq.scss"
import { dedicatedFaqs } from "../../utils/siteData";
import { buildFAQSchema } from "../../utils/schemaBuilders";
import SchemaMarkup from "../SchemaMarkup/SchemaMarkup";

const Faq = () => {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const redirectDomain = determineAppEnvironment();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const faqSchema = buildFAQSchema(dedicatedFaqs);

    return (
        <div className="faq-page">
            <SchemaMarkup schema={faqSchema} />
            <div className="ezBannerContainer">
                <img src={`${redirectDomain}/public/images/banners/faq.jpg`} className="ezStaticBannerImg" alt="FAQ" />
            </div>

            <div className="ezClockerBasicContentContainer">
                <button onClick={() => navigate("/")} className="headerButton">Return to the ezClocker main page</button>
                {/*--- desktop code ---*/}
                <div className="faq-desktop">
                    {dedicatedFaqs.map((faq) => (
                        <div className="faq-section" key={faq.id}>
                            <h1 className="faq-question">{faq.question}</h1>
                            <hr />
                            <div className="faq-answer">
                                <p dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                                {faq.video && (
                                    <>
                                        <br />
                                        <br />
                                        <h2 className="video-heading">Please check out this video for an overview</h2>
                                    </>
                                )}
                            </div>
                            {faq.video && faq.video.desktop && (
                                <embed
                                    src={faq.video.desktop}
                                    wmode="transparent"
                                    className="video-container"
                                    allow="autoplay; encrypted-media; picture-in-picture"
                                    title="Employee Time Tracking and Scheduling Software - ezClocker"
                                    frameBorder={0}
                                    allowFullScreen></embed>
                            )}
                        </div>
                    ))}
                </div>

                {/*--- mobile code ---*/}
                <div className="faq-mobile">
                    {dedicatedFaqs.map((faq) => (
                        <Accordion key={faq.id} expanded={expanded === faq.id} onChange={handleChange(faq.id)}>
                            <AccordionSummary
                                expandIcon={<FaChevronDown />}
                                aria-controls={`${faq.id}-content`}
                                id={`${faq.id}-header`}
                            >
                                <h1 className="faq-question">{faq.question}</h1>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="faq-answer">
                                    <p dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                                    {faq.video && (
                                        <>
                                            <br />
                                            <br />
                                            <h2 className="video-heading">Please check out this video for an overview</h2>
                                        </>
                                    )}
                                </div>
                                {faq.video && faq.video.mobile && (
                                    <embed
                                        src={faq.video.mobile}
                                        wmode="transparent"
                                        className="video-container"
                                        allow="autoplay; encrypted-media; picture-in-picture"
                                        title="Employee Time Tracking and Scheduling Software - ezClocker"
                                        frameBorder={0}
                                        allowFullScreen></embed>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>

                <button onClick={() => navigate("/")} className="headerButton">Return to the ezClocker main page</button>
            </div>
        </div>
    )
}

export default Faq;
